import _defineProperty from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["min", "max", "step", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { DualThumb } from './components/DualThumb/DualThumb.js';
import { SingleThumb } from './components/SingleThumb/SingleThumb.js';
import { useUniqueId } from '../../utilities/unique-id/hooks.js';

function RangeSlider(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var id = useUniqueId('RangeSlider');

  var sharedProps = _objectSpread({
    id: id,
    min: min,
    max: max,
    step: step
  }, rest);

  return isDualThumb(value) ? /*#__PURE__*/React.createElement(DualThumb, Object.assign({
    value: value
  }, sharedProps)) : /*#__PURE__*/React.createElement(SingleThumb, Object.assign({
    value: value
  }, sharedProps));
}

function isDualThumb(value) {
  return Array.isArray(value);
}

export { RangeSlider };